import React, { useEffect, useRef } from 'react';

interface SvgUrlImageProps {
  url: string;
  className?: string;
}

export default function SvgUrlImage({ url, className }: SvgUrlImageProps) {
  const svgContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const xhr = new XMLHttpRequest();
    const svgContainer = svgContainerRef.current;

    xhr.open('GET', url, true);
    xhr.responseType = 'document';
    xhr.onload = () => {
      const svgContent = xhr?.responseXML?.documentElement;

      if (svgContainer && svgContent) {
        svgContainer?.appendChild(svgContent);
      }
    };

    xhr.send();

    return () => {
      if (svgContainer) {
        svgContainer.innerHTML = '';
      }
    };
  }, [url]);

  return (
    <div className={className} ref={svgContainerRef} />
  );
}
